import { isBuildIn } from '@flowus/common/build-in';
import { i18n } from '@flowus/common/i18n';

export const getCurrencySymbols = (type?: number): string => {
  if (type === undefined && isBuildIn()) {
    type = 2;
  }
  switch (type) {
    case 0:
      return i18n.t('common.points');
    case 1:
      return '¥';
    case 2:
      return '$';
    case 3:
      return '€';
    default:
      return '¥';
  }
};
